import * as Yup from "yup";
import {
    phoneRegex,
    zipRegex,
    cityRegEx,
    dateCantBeInFuture,
    stateRegEx
} from "./validationFunctions";


export const authorizationToReleaseValidations = (section) => {
    if (section.active) {
        return Yup.object().shape({

            facilityList: Yup.array().min(1, "Please select at least one facility to authorize the release of data."),

            CustomPhysicianTextReady: Yup.object().test("CustomPhysicianTextReady",
                'If facility is selected, please enter a valid value',
                function (textHash) {
                    if (textHash) {
                        for (const key of Object.keys(textHash)) {
                            if (!textHash[key]) {
                                return false;
                            }
                        }
                    }
                    return true;
                }),

            discloseTo: Yup.string()
                .required(
                    () =>
                        "Please specify the party to whom the records should be disclosed"
                ),

            RFName: Yup.string()
                .required(
                    () =>
                        "Please provide a first name"
                ),
            RLName: Yup.string()
                .required(
                    () =>
                        "Please provide a last name"
                ),

            RPhone: Yup.string()
                .required(
                    () =>
                        "Please provide a phone number"
                )
                .matches(
                    phoneRegex,
                    'Please enter phone number in a valid format'
                ),

            RFax: Yup.string()
                .matches(
                    phoneRegex,
                    'Please enter fax number in a valid format'
                ),

            RAddress1: Yup.string()
                .required(
                    () =>
                        "Please provide an address"
                ),

            RCity: Yup.string()
                .required(
                    () =>
                        "Please provide a city"
                )
                .matches(cityRegEx, 'City must contain only letters'),

            RState: Yup.string()
                .required(
                    () =>
                        "Please provide a state"
                )
                .matches(stateRegEx, 'State must contain only letters'),


            RZip: Yup.string()
                .required(
                    () =>
                        "Please provide a zip"
                ).matches(zipRegex, "Invalid Zip Code"),

            REmail: Yup.string()
                .email(
                    'Please provide a valid email address'
                ),

        });
    } else { return Yup.object().shape(); }
};
